// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Chip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

// project imports
import LogoSection from '../LogoSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    return (
        <>
            <Avatar
                variant="rounded"
                sx={{
                    ...theme.typography.commonAvatar,
                    ...theme.typography.mediumAvatar,
                    overflow: 'hidden',
                    transition: 'all .2s ease-in-out',
                    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.main,
                    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                    '&:hover': {
                        background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                    }
                }}
                onClick={() => dispatch(openDrawer(!drawerOpen))}
                color="inherit"
            >
                <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
            <Box sx={{ flexGrow: 2 }} />
            <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                <LogoSection />
            </Box>

            <Chip label="0 Forms" avatar={<ShoppingCartIcon />} />
            <Box sx={{ p: 1 }} />

            <NotificationsIcon />
            <Box sx={{ p: 1 }} />

            <Avatar color="primary" sx={{ fontSize: '1rem' }}>
                AG
            </Avatar>
        </>
    );
};

export default Header;
